module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/brain-b37cbdef9609023b4073b79babe34b56.png";